module.exports = __webpack_public_path__ + "static/03-ae8b86b0c30348c2ccde188edb391bce.png";